import React from 'react';

const SvgSemaphorePositiveBw = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 17.81 17.81"
        {...props}
    >
        <defs>
            <linearGradient
                id="semaphore_positive_bw_svg__a"
                x1={15.2}
                y1={16.25}
                x2={2.61}
                y2={28.85}
                gradientTransform="matrix(1 0 0 -1 0 31.46)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#b0adad" />
                <stop offset={1} stopColor="#e4e4e5" />
            </linearGradient>
            <linearGradient
                id="semaphore_positive_bw_svg__b"
                x1={6.11}
                y1={25.23}
                x2={11.38}
                y2={19.96}
                gradientTransform="matrix(1 0 0 -1 0 31.46)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#fff" stopOpacity={0} />
                <stop offset={1} stopColor="#010101" stopOpacity={0.75} />
            </linearGradient>
        </defs>
        <g data-name="Vrstva 2">
            <g data-name="Vrstva 1">
                <g data-name="Vrstva 2">
                    <g data-name="\u0160ed\xFD zelen\xFD">
                        <circle
                            cx={8.91}
                            cy={8.91}
                            r={8.91}
                            style={{
                                fill: "url(#semaphore_positive_bw_svg__a)",
                            }}
                        />
                        <image
                            width={67}
                            height={68}
                            transform="matrix(.16 0 0 .16 3.46 3.46)"
                            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABECAYAAADaz4jLAAAACXBIWXMAAEVbAABFWwG1AX/6AAAGRUlEQVR4Xu2b/2/bNhDFP3LtVHFSZG2BFRuw//8fGzZ0wJIVzRc3TuL9cHzWiaZESaaKBvUDCMWWyJKPd8e7J7fa7XacYFjkHviZsMw9UAqruq6ir+LPQstUt5vNdzPdak43CQT4RvR3F3Y0pOjv3dzEzEKGI2EBvImuMTkxdq69AM/RdTZS5nKTClv8EjhzbUmblBQ8CU/Ao2tP4ftZyChuGcEq3gAroAYuQluHz2fhvncbaLvFM7b4DXAP3IW2AbbA8xzWMYdliIwzjIRfgPehvcMIWdGcZDEZL9iCN8BX4CY03VN7NWQsaMh4D/wGfAI+hO/eknYVucg3zBKuMfLACPqGWUwuAE9CUTJc4JRlrDEyPgF/AL8CV9gCvasIcpEN8AUjjvD5NrQ3QLWq66q0qxQlw2GBjV1jrvEBI+J3jJw1DRneTUTGPQ0R3kKWzJgozkFGbB0KolcYER8xMlILe8FOjPPw+S70jQPvj+8mAXGOscJiRI2RsMYWuCRtGU/h80Po8zaMEecpxVGaDH9celJEjHKPJbbAVMyAJh8RAalkraLwiVKajC7E5FQcLk4LSz3zXTBbMAqIF1N1XIfcm52Uucl4VTiR4XAiwyEbQEeIMrqXCo7H+Lsfo9VWdd21mZMEoiQZR4gyFXZk6viMj8ex6DuWof9o3QtEq7oeJBC1yDhSlCHcW2KJ1TmWMEnH8PlCDpqD0vozbKxzbGyw5KxrYZ0C0aquOwWi2DIqposy0JBxjqXeV1i2ec6hjtEHzeMM66t0/i7cX5MnY7RAtCcjWIUvsIaKMh5axFts8irbL2nrGDlCFzTi0CU2xn24f4GV8qkFDRWIdqu6PrAObxl+N8aIMjH8GB8wQlSpqsbocjd9r5pGEsAm3F9jC3rEFhvjKIEoJmPBNFEmHkOucklD6AU29lDL8PMA24yPWAH3RLfaJRcZLRAtoYgo46HAp/JdVarIyPWPLRTMSi6xnX6k2dkU5CKjBaI4gPqYMVSUSUGn0Co0H4j9yRRD3/l5LDCLfEcQg+knQmSMFohiN/G7MkaUiaGxUkd0ri+045KsbP/ehP78YrJAlCLD7+oQUaYPVaJBf98KW6wsaEE7b+iDnpkkEIkMP0lPioiJs78hRAj+2aH9Un1yRAh6LpUBpzalM2bEiMlJ7fKcGEukFpaabxZd/hsPUHVcfzT0zTNLypBg9tOgi4w4WO06rj8a+uaZDcC5mOGjeHysDSVkrN97pDYkh9R8B/UVGX6BfjBVfqr+dGRl/S+gK+Dm+qbmM2RRekZz1dx9LdK5od4yPAnPNHm8qj4lMSWSrh3dhGiCfjP8NUeKkq770DbYOnz2mhwjRYYvfe9o5/cPHJ+O634fUlrElvHp+A02f5XuqnazZEDDqkrfa9r5/bGFWk2byHgcb52ah3QI7fLYQu0fbB1fw3eqeA+wBBNMg04oqxCrKn2V3x9TwkNDVN8Yfh53wH80esQt00r4z6H/Pc46+sQdDaJJSAzZ0FR8U8QdCTOqdc7o9/nUPP7GFnTNceKO+iaJjMnwOwI24C3TZT9JdZLv3tH22S43UQCXhX4G/gzXLxwn+/m40cKejOAq3ldlarc0RU+feRPuyUW8ePuR5sdpXeYtyDK0s7c0pv4XRo5cpWscjREHYQnCL0PUcTHqTTUue4eQITn/AiPlgZ4dScDv7APNqXYD/IvtdI4Mta7j+QAtMgJbCqYvHEb+XLJU0bzgWdPojQp4OasQ9O/LUh+xsR5o8octeQvbRX8Pf4kkiBSY9HoRujPAsVC/OAvekreMPY56veiRGKhz4PDucxe13j4DcLC7atvNZgrBnchlgj8VTmQ4nMhwOJHhMDcZPojqc+o65N4xQXgQsqdJIfhT4IX24lKL9s/MToJQmozUMdiVK0A7kdPzk1SqEihNBrRJUME1VDFTxjlapSqBOckYq5j5fqNVqhKYgwxodnisYiYyRqtUJVCUjAKKmdxrtEpVAkXJCNCCxipmWpzXMgarVCUwFxlTFDN/SoxWqUqg+H/lhH31qp8xjP0JpT+JUirVc+lqVZjDMqDZXe8yQxUzn08MVqlKYBbLEI742bU/PvfkzBE0PWYlw2OEYtaa0NwEeHw3Ml4D5q5aXxVOZDj8D/ksTG9R+tVcAAAAAElFTkSuQmCC"
                            style={{
                                opacity: 0.25,
                                isolation: "isolate",
                            }}
                        />
                        <path
                            style={{
                                fill: "#fff",
                            }}
                            d="M12.79 7.63H9.97V4.84H7.53v2.79H4.71v2.44h2.82v2.84h2.44v-2.84h2.82V7.63z"
                        />
                        <path
                            style={{
                                fill: "url(#semaphore_positive_bw_svg__b)",
                                opacity: 0.25,
                                isolation: "isolate",
                            }}
                            d="M12.79 7.63H9.97V4.84H7.53v2.79H4.71v2.44h2.82v2.84h2.44v-2.84h2.82V7.63z"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default SvgSemaphorePositiveBw;